import React, { useState, useEffect, useRef } from "react";

const RenderIndoItemsCMKIDS = ({ indo, startIndex, indexxx }) => {
  const [scale, setScale] = useState(1);
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const innerRef = useRef(null);
  const lastScaleRef = useRef(1);
  const lastContentWidthRef = useRef(0);
  const isCalculatingRef = useRef(false);
  const calculationCountRef = useRef(0);

  // Sadece indo değiştiğinde hesapla - ResizeObserver kaldırıldı
  useEffect(() => {
    if (!containerRef.current || !contentRef.current) {
      console.log("RenderIndoItemsCMKIDS: Refs hazır değil");
      return;
    }

    if (isCalculatingRef.current) {
      console.log("RenderIndoItemsCMKIDS: Zaten hesaplama yapılıyor, atlanıyor");
      return;
    }

    isCalculatingRef.current = true;
    calculationCountRef.current += 1;
    console.log(`RenderIndoItemsCMKIDS: Hesaplama başladı #${calculationCountRef.current}, indo.length: ${indo?.length}`);

    const timeoutId = setTimeout(() => {
      if (!containerRef.current || !contentRef.current) {
        console.log("RenderIndoItemsCMKIDS: Timeout içinde refs hazır değil");
        isCalculatingRef.current = false;
        return;
      }

      const containerWidth = containerRef.current.offsetWidth;
      const contentWidth = contentRef.current.scrollWidth;
      const maxWidth = 106;

      console.log(`RenderIndoItemsCMKIDS: containerWidth: ${containerWidth}, contentWidth: ${contentWidth}, maxWidth: ${maxWidth}`);

      // İçerik genişliği değişmediyse işlem yapma
      if (Math.abs(contentWidth - lastContentWidthRef.current) < 1 && lastContentWidthRef.current > 0) {
        console.log("RenderIndoItemsCMKIDS: İçerik genişliği değişmedi, atlanıyor");
        isCalculatingRef.current = false;
        return;
      }

      lastContentWidthRef.current = contentWidth;

      let newScale = 1;

      if (contentWidth > maxWidth) {
        newScale = maxWidth / contentWidth;
        console.log(`RenderIndoItemsCMKIDS: maxWidth aşıldı, newScale: ${newScale}`);
      } else if (contentWidth > containerWidth && containerWidth > 0) {
        newScale = containerWidth / contentWidth;
        console.log(`RenderIndoItemsCMKIDS: containerWidth aşıldı, newScale: ${newScale}`);
      } else {
        newScale = 1;
        console.log(`RenderIndoItemsCMKIDS: Normal boyut, newScale: ${newScale}`);
      }

      // Sadece scale gerçekten değiştiyse güncelle
      if (Math.abs(newScale - lastScaleRef.current) >= 0.001) {
        console.log(`RenderIndoItemsCMKIDS: Scale değişti ${lastScaleRef.current} -> ${newScale}, setScale çağrılıyor`);
        lastScaleRef.current = newScale;
        setScale(newScale);
      } else {
        console.log(`RenderIndoItemsCMKIDS: Scale değişmedi (${lastScaleRef.current}), setScale çağrılmıyor`);
      }

      isCalculatingRef.current = false;
      console.log(`RenderIndoItemsCMKIDS: Hesaplama tamamlandı #${calculationCountRef.current}`);
    }, 300);

    return () => {
      console.log(`RenderIndoItemsCMKIDS: Cleanup, timeout iptal ediliyor`);
      clearTimeout(timeoutId);
      isCalculatingRef.current = false;
    };
  }, [indo?.length]);

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <div
        ref={containerRef}
        style={{
          display: "flex",
          width: "100%",
          maxWidth: "106px",
          overflow: "hidden",
        }}
      >
        <div
          ref={contentRef}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "nowrap",
            transform: `scale(${scale})`,
            transformOrigin: "center",
            transition: "transform 0.3s ease",
            margin: "0 auto",
            gap:"1mm",
            marginTop:"4.68px",
            maxWidth: "106px",
          }}
        >
          {indo.map((item, index) => {
            // `indexxx` içindeki mevcut sırayı kontrol et
            const isHighlighted = startIndex === indexxx[index];

            return (
              <div
                key={index}
                ref={innerRef}
                style={{
                  height: "3.577mm",
                  minWidth: "4mm",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: isHighlighted ? "black" : "transparent",
                  color: isHighlighted ? "white" : "black",
                  textAlign: "center",
                }}
              >
                    <p
            className="arial-bold"
            style={{
              fontSize: "4pt",
              margin: 0,
              flexWrap: "nowrap",
              whiteSpace: "nowrap",
              fontWeight:"bold",
              letterSpacing: 0,
              paddingLeft:4,
              paddingRight:4,
           
              lineHeight:"5pt",

            }}
          >
            {item?.cm?.trim().replace(/\s*x\s*/g, 'x')}
            <br />
            {item?.inches?.trim().replace(/\s*x\s*/g, 'x')}
          </p>

              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RenderIndoItemsCMKIDS;
